export const getAPIBaseURL = () => {
  let url = ""
  const { host } = window.location
  if (host.indexOf("qa-quality.sidsfarm.com") !== -1) {
    url = "https://sf-newqa-api.dev.sidsfarm.com/api/v3/";
  } else if (host.indexOf("quality.sidsfarm.com") !== -1) {
    url = "https://apiv3.sidsfarm.com/api/v3/"
  } else {
    url = "https://sf-newqa-api.dev.sidsfarm.com/api/v3/";
  }
  return url
};

export const getDefaultHeaders = () => {
  const headers = {
    "Content-Type": "application/json",
  };
  return headers;
};
